module.exports = {
  ADD_GOAL_MODAL: 'ADD_GOAL_MODAL',
  ADD_WEIGHT_MODAL: 'ADD_WEIGHT_MODAL',
  ADD_EXERCISE_MODAL: 'ADD_EXERCISE_MODAL',
  ADD_FOOD_MODAL: 'ADD_FOOD_MODAL',
};
